import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTransactionHistory } from '../../../../../redux/features/CRDslice';

import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from '@mui/material';
import Loader3D from '../../../../../components/Loader/Loader3D';

const ViewTransactionHistory = ({ id }) => {
  const dispatch = useDispatch();
  const { loading, transactionHistory = [] } = useSelector((store) => store.crd);

  useEffect(() => {
    if (!id) return;
    dispatch(getTransactionHistory(id));
  }, [id, dispatch]);

  const totalIncomeAmount = useMemo(() => {
    return transactionHistory.reduce((sum, row) => sum + Number(row?.income_amount || 0), 0);
  }, [transactionHistory]);

  return (
    <Box>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
          <Loader3D />
        </Box>
      ) : (
        <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
          <Table
            size="small"
            sx={{
              borderCollapse: 'collapse',
              '& th, & td': {
                border: '1px solid #e5e7eb',
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell>
                  <b>Sl No</b>
                </TableCell>
                {/* <TableCell><b>Income ID</b></TableCell> */}
                <TableCell>
                  <b>Transaction Date</b>
                </TableCell>
                <TableCell>
                  <b>Fee Type</b>
                </TableCell>
                <TableCell align="right">
                  <b>Amount</b>
                </TableCell>
                <TableCell>
                  <b>Accountant Verification</b>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {transactionHistory.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center" sx={{ py: 3 }}>
                    No Transactions Found
                  </TableCell>
                </TableRow>
              ) : (
                <>
                  {transactionHistory.map((row) => (
                    <TableRow sx={{ py: 1 }} key={row.income_id}>
                      <TableCell>{row.sl_no}</TableCell>
                      {/* <TableCell>{row.income_id}</TableCell> */}
                      <TableCell>{row.income_transaction_date}</TableCell>
                      <TableCell>{row.fee_type}</TableCell>
                      <TableCell align="right">{row.income_amount}</TableCell>
                      <TableCell>{row.income_accountant_verification === 1 ? 'Yes' : 'No'}</TableCell>
                    </TableRow>
                  ))}

                  {/* ✅ TOTAL ROW */}
                  <TableRow>
                    <TableCell colSpan={3} align="right" sx={{ fontWeight: 700 }}>
                      Total
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: 700 }}>
                      {totalIncomeAmount}
                    </TableCell>
                    <TableCell />
                  </TableRow>
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default ViewTransactionHistory;
